import React, { createContext, useContext, useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';

export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const { currentUser, loading } = useContext(AuthContext);
  const [projects, setProjects] = useState([]);
  const [projectsSummary, setProjectsSummary] = useState(null);
  const [projectsloading, setProjectsLoading] = useState(true);

  const fetchProjects = async () => {
    try {
      setProjectsLoading(true);
      const res = await fetch('/api/projects');
      const text = await res.text();
      console.log("Проекты: статус", res.status, "тело:", text);
  
      if (!res.ok) {
        setProjects([]); // 🛡 защита при 403 и т.п.
        setProjectsSummary(null);
        return;
      }
  
      const data = JSON.parse(text);
      if (data && Array.isArray(data.projects)) {
        setProjects(data.projects);
        setProjectsSummary(data.summary || null);
      } else {
        console.warn("⚠️ Некорректный формат ответа /api/projects", data);
        setProjects([]);
        setProjectsSummary(null);
      }
    } catch (err) {
      console.error('Ошибка загрузки проектов:', err);
      setProjects([]); // 🛡 на всякий
      setProjectsSummary(null);
    } finally {
      setProjectsLoading(false);
    }
  };
  

  useEffect(() => {
    if (loading) return;

    if (!currentUser) {
      setProjects([]);
      setProjectsSummary(null);
      setProjectsLoading(false);
      return;
    }

    fetchProjects();
  }, [currentUser, loading]);

  return (
    <ProjectContext.Provider
      value={{ projects, projectsSummary, setProjects, fetchProjects, projectsloading }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
